import { NotificationService } from 'app/shared/utils/notification.service';
import { SummernoteDirective } from './../../shared/forms/editors/summernote.directive';
import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';
import { BsModalRef, BsModalService, TypeaheadMatch } from 'ngx-bootstrap';
import { AssetEmailDto } from 'app/client-core/dtos/asset-email.model';
import { TacticService } from 'app/client-core/services/tactic.service';
import { ValidationMessage } from 'app/validation';
import { SummernoteAttachDirective } from 'app/shared/forms/editors/summernote-attach.directive';
import { TacticAssetslistItemDTO } from 'app/client-core/dtos/tactics.model';
import { UserService } from 'app/client-core/services/user.service';
import { Observable } from 'rxjs';
import { ProgramDto, ShippingLocationDto } from 'app/client-core/dtos/programs.model';
import { ProgramService } from 'app/client-core/services/program.service';
import { ApiResponse } from 'app/client-core/api-response-models';
import { StatesSelectComponent } from 'app/shared/selects/states/states-select.component';

const $ = jQuery;
@Component({
    selector: 'address-edit-modal',
    templateUrl: './address-edit.modal.component.html',
    styleUrls: [
        './address-edit.scss'
    ]
})
export class AddressEditModalComponent implements OnInit {
    ready: boolean;
    public validationMessages: ValidationMessage;
    shippingLocationDto: ShippingLocationDto = {} as ShippingLocationDto;
    @Input() selectedId: number;
    programDto: ProgramDto = new ProgramDto();
    submited: boolean;
    submitted: boolean;
    selectedProgramId: number;
    fromCampaigns: any;
    @ViewChild("state") state: StatesSelectComponent;

    onAfterValidate(isValid: boolean): void {
        console.log('>>IsValid', isValid);
        this.submited = true;
        if (!isValid)
            return;

        this.onSubmitShipping();
    }

    validatorOptions = {
        //container: '#messages',
        message: "Field is invalid",
        feedbackIcons: {
            valid: 'fa fa-check',
            invalid: 'fa fa-times',
            validating: 'fa fa-refresh'
        },
        fields: {
            city: {
                validators: {
                    notEmpty: {
                        message: "City is required"
                    }
                }
            },
            address1: {
                validators: {
                    notEmpty: {
                        message: "Address1 is required"
                    }
                }
            },
            zip: {
                validators: {
                    notEmpty: {
                        message: "Zip is required"
                    }
                }
            }
        }
    };

    constructor(
        public modalRef: BsModalRef,
        private programService: ProgramService,
        private notificationService: NotificationService
    ) {
    }

    ngOnInit() {
        this.ready = false;
        this.programService.getShippingLocationToEdit(this.selectedId).subscribe(res => {
            this.shippingLocationDto = res.data;
            this.ready = true;
            setTimeout(() => {
                this.state.item = this.shippingLocationDto.state;
            }, 300);
        })
    }

    close(): void {
        this.modalRef.hide();
    }

    deleteAddress() {
        this.notificationService.smartMessageBox({
            title: "<i class='fa fa-trash text-danger'></i> Are you sure you want to remove this address?",
            content: "",
            buttons: '[Cancel][Yes]'

        }, (ButtonPressed, Value) => {
            if (ButtonPressed == "Yes") {
                this.programService.updateShippingLocation({
                    ...this.shippingLocationDto,
                    delete: 1
                }).subscribe(() => {
                    this.programService.shippingLocationUpdated.next();
                    this.close();
                });
            }
        });
    }

    onStatesTypeaheadSelected($event: TypeaheadMatch): void {
        if ($event && $event.item.stateCode)
            this.shippingLocationDto.state = $event.item.stateCode;
    }

    onCountriesTypeaheadSelected($event: TypeaheadMatch): void {
        if ($event && $event.item.id)
            this.shippingLocationDto.country = $event.item.countryCode;
    }

    onStateSelected($event) {
        console.log('onStateSelected', $event);
        this.shippingLocationDto.state = $event;
    }

    onSubmitShipping() {
        return new Promise((resolve, reject) => {
            this.submitted = false;

            if (!this.canSubmitShippingLocation()) {
                this.submitted = true;
                this.validationMessages = new ValidationMessage(null, true, "there are some validation errors.");
                reject()
                return;
            }

            let observe: Observable<ApiResponse<any>>;
            observe = this.programService.updateShippingLocation(this.shippingLocationDto);
            observe.subscribe(res => {
                if (!res.hasError) {
                    this.validationMessages = new ValidationMessage(null, true, "Shipping location updated").isSuccess();
                    console.log('>>ShippingLocationSubmit', res.data);
                    this.programService.shippingLocationUpdated.next();
                    this.close();
                    resolve(true);
                } else {
                    this.validationMessages = new ValidationMessage(res.error, true, "shipping location not be saved");
                    reject();
                }
            },
                (err: any) => {
                    this.validationMessages = new ValidationMessage(null, true, "Unexpected error occured");
                    reject();
                },
                () => {
                });
        })
    }

    isCountryValid() {
        return this.shippingLocationDto.country != null && this.shippingLocationDto.country !== undefined;
    }

    isStateValid() {
        console.log(this.shippingLocationDto.state)
        return this.shippingLocationDto.state != null && this.shippingLocationDto.state !== undefined;
    }

    canSubmitShippingLocation() {
        return this.isCountryValid() &&
            this.isStateValid();
    }
}





// WEBPACK FOOTER //
// ./src/app/shared/components/address-edit/address-edit.modal.component.ts